import { CircularProgress, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { formatWarehouseName } from '../../helpers/formatWarehouseName';
import { useDataWarehouses } from '../../hooks/useDataWarehouses';

type WarehouseSelectorMuiProps = {
  value: string | undefined;
  onChange: (warehouseName: string) => void;
  label?: string;
};

/** @deprecated Legacy MUI copy - migrate consumers to the Encore WarehouseSelector and delete. */
export const WarehouseSelectorMui = ({
  value,
  onChange,
  label = 'Data warehouse',
}: WarehouseSelectorMuiProps) => {
  const { warehouses, primaryWarehouse, isLoading, error } =
    useDataWarehouses();

  if (warehouses.length <= 1 && !isLoading && !error) return null;

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (error) {
    return <Alert severity="error">Failed to load warehouses</Alert>;
  }

  return (
    <TextField
      select
      label={label}
      value={value ?? primaryWarehouse?.name ?? ''}
      onChange={e => onChange(e.target.value)}
      fullWidth
      InputLabelProps={{ shrink: true }}
     data-track-source-anchor="3b8e80540a;warehouse-selector-mui-text-field">
      {warehouses.map(warehouse => (
        <MenuItem key={warehouse.name} value={warehouse.name} data-track-source-anchor="542ae33946;warehouse-selector-mui-menu-item;low">
          {formatWarehouseName(warehouse)}
        </MenuItem>
      ))}
    </TextField>
  );
};
